import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import selectDeviceType from 'redux/selectors/selectDeviceType'
import selectIsNavigationVisible from 'redux/selectors/selectIsNavigationVisible'
import selectMouseAbilityOpen from 'redux/selectors/selectMouseAbilityOpen'
import selectPageView from 'redux/selectors/selectPageView'

// disables body scrolling when menu, left or right are open on mobile, using the same tactic that MUI does
// using a react component despite not really needing to render anything because I want to borrow component lifecycle behaviour
// plus it lets me use it in other components in a pretty tidy way.

// Could this be refactored into a useMobileScrollBlocker hook ?
const MobileScrollBlocker = () => {
  const { isMobile = false } = useSelector(selectDeviceType)
  const pageView = useSelector(selectPageView)
  const rightOpen = useSelector(selectMouseAbilityOpen)
  const menuOpen = useSelector(selectIsNavigationVisible)

  const [currentlyStyled, setCurrentlyStyled] = useState(false)
  const [prevStyle, setPrevStyle] = useState('') // should avoid clashes with mui doing the same hopefully

  const leftOpen = pageView === 'left'

  useEffect(() => {
    const scrollBlockersOpen = leftOpen || rightOpen || menuOpen
    // if not mob and not styled don't do anything, or if styled and should remain so
    if (
      (!isMobile && !currentlyStyled) ||
      (currentlyStyled && scrollBlockersOpen)
    ) {
      return
    }
    // if styled and none of the scroll blockers are open or its not a mobile view, unstyle
    if (!isMobile || (currentlyStyled && !scrollBlockersOpen)) {
      document.body.style.overflowY = prevStyle
      setCurrentlyStyled(false)
      return
    }
    // if not styled and a blocker is open, save current style and override
    if (!currentlyStyled && scrollBlockersOpen) {
      setPrevStyle(document.body.style.overflowY)
      document.body.style.overflowY = 'hidden'
      setCurrentlyStyled(true)
    }
  }, [isMobile, leftOpen, rightOpen, menuOpen])

  return <>{/* empty */}</>
}

export default MobileScrollBlocker
